/** Horizontal gap between SEO links (`gap-x-6`). */
export const SEO_LINK_GAP_PX = 24;

export const LAST_LINK_GAP_PX = 16;

/** Toggle control width (`size-6`). */
export const SEO_LINK_TOGGLE_BUTTON_PX = 24;

/**
 * How many links fit on the first row. When not all links fit, reserves space for the +/- toggle on the right.
 */
export function countSeoLinksOnFirstRow(availableWidth: number, linkWidths: readonly number[]): number {
    const n = linkWidths.length;
    if (n === 0) return 0;
    if (availableWidth <= 0) return 0;

    let totalAll = 0;
    for (let i = 0; i < n; i++) {
        totalAll += linkWidths[i] ?? 0;
        if (i > 0) totalAll += SEO_LINK_GAP_PX;
    }
    if (totalAll <= availableWidth + 0.5) {
        return n;
    }

    const availableWithToggle = availableWidth - (SEO_LINK_TOGGLE_BUTTON_PX + LAST_LINK_GAP_PX);
    for (let k = n; k >= 0; k--) {
        let total = 0;
        for (let i = 0; i < k; i++) {
            total += linkWidths[i] ?? 0;
            if (i > 0) total += SEO_LINK_GAP_PX;
        }
        if (total <= availableWithToggle + 0.5) {
            return k;
        }
    }
    return 0;
}

/**
 * measure how many fit on one row (with toggle reserved when needed).
 */
export function resolveSeoLinksVisibleCount(availableWidth: number, linkWidths: readonly number[]): number {
    const n = linkWidths.length;
    if (n === 0) return 0;
    return countSeoLinksOnFirstRow(availableWidth, linkWidths);
}
